var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('div',{staticClass:"main"},[_c('router-view')],1),_c('div',{staticClass:"tabbar-content"},[_c('Tabbar',{attrs:{"count":_vm.count}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }